import { render, staticRenderFns } from "./Car.vue?vue&type=template&id=28d9420c&"
import script from "./Car.vue?vue&type=script&lang=js&"
export * from "./Car.vue?vue&type=script&lang=js&"
import style0 from "./Car.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports